import styled from "styled-components";
import { staticText } from "../../statics/static-text";

// TEXT
export const text = { ...staticText.errorFlag, shared: staticText.shared };

// STYLES

export const Container = styled.div`
  display: flex;
  width: 40rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const Spacer = styled.div<{ $height: string }>`
  height: ${({ $height }) => $height};
  min-height: ${({ $height }) => $height};
  flex-shrink: 0;
`;

// DATA

// TYPES
export interface ErrorFlagProps {
  customHeader?: string;
  customMessage?: string;
  showButton?: "backToHomepage" | "signOut";
}

// CONSTANTS

// FUNCTIONS

// ASSETS
